"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _times = require("HubStyleTokens/times");

var _TwoWayTransition = _interopRequireDefault(require("../../transitions/TwoWayTransition"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

var _overlayTransitionMixin = require("./overlayTransitionMixin");

var _UIDialog = _interopRequireDefault(require("../UIDialog"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", " {\n    transition-property: ", ";\n    transition-delay: ", "ms;\n    transition-duration: ", "ms;\n    opacity: ", ";\n    transform: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var totalTransitionTime = parseInt(_times.DEFAULT_MODAL_TRANSITION_TIMING, 10);
var overlayTransitionTime = parseInt(_times.MODAL_BACKGROUND_TRANSITION_TIMING, 10);
var dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
var overlayTransition = (0, _overlayTransitionMixin.getOverlayTransition)(dialogTransitionTime);
var ModalTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "ModalTransition__ModalTransitionWrapper",
  componentId: "sc-1vxbshk-0"
})(_templateObject(), _UIDialog.default.Selector, function (_ref) {
  var transitionActive = _ref.transitionActive;
  return transitionActive ? 'opacity, transform' : 'none';
}, overlayTransitionTime, dialogTransitionTime, function (_ref2) {
  var open = _ref2.open;
  return open ? '1' : '0';
}, function (_ref3) {
  var open = _ref3.open;
  return "scale(" + (open ? '1' : '0.9') + ")";
}, overlayTransition);

var ModalTransition = function ModalTransition(props) {
  return _react.default.createElement(_TwoWayTransition.default, (0, _extends2.default)({}, props, {
    ContextProvider: _ModalTransitionContext.ModalTransitionContextProvider,
    duration: totalTransitionTime,
    transitionOnMount: true,
    Wrapper: ModalTransitionWrapper
  }));
};

ModalTransition.displayName = 'ModalTransition';
var _default = ModalTransition;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/dialog/internal/ModalTransition.js
// module id = 795
// module chunks = 209 210 211 212